<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Attach to Equipment</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <div class="input-container">
            <span class="label">Implement</span>
            <select (change)="implementSelected($event.target.value)" *ngIf="!hasImplement" class="get-Input">
                <option value="" disabled selected>Select Implement</option>
                <option *ngFor="let implement of implementList" [value]="implement.ImplementId">{{implement.Name}}</option>
            </select>
            <span *ngIf="hasImplement" class="label">{{impName}}</span>
        </div>


        <div class="input-container" *ngIf="hasImplement">
            <span class="label">Customer</span>
            <select (change)="customerSelected($event.target.value)" class="get-Input">
                <option value="" disabled selected>Select Customer</option>
                <option *ngFor="let customer of customerList" [value]="customer.Id"> {{customer.Name}}</option>
            </select>
        </div>


        <div class="input-container">
            <span class="label">Job Site</span>
            <span *ngIf="!hasImplement" class="label">{{jobsiteName}}</span>
            <select (change)="jobsiteSelected($event.target.value)" *ngIf="hasImplement" class="get-Input">
                <option value="" disabled selected>Select Jobsite</option>
                <option *ngFor="let job of jobsiteList" [value]="job.Id"> {{job.Name}}</option>
            </select>
        </div>
        <div class="input-container">
            <span class="label">Equipment</span>
            <select (change)="equipmentSelected($event.target.value)" *ngIf="hasImplement" class="get-Input">
                <option value="" disabled selected>Select Equipment</option>
                <option *ngFor="let eqmt of equipment" [value]="eqmt.equipmentId">{{eqmt.equipmentSerialNo}} : {{eqmt.equipmentUnitNo}}</option>
            </select>
            <span *ngIf="!hasImplement" class="label">{{equipmentName}}</span>
        </div>
        <div class="input-container">
            <span class="label">Equipment SMU</span>
            <input type="number" value="0" min="0" [(ngModel)]="smu" (ngModelChange)="smuChanged()" class="get-Input"/>
            <span class="input-icon">Hrs</span>
        </div>
        <!-- <div class="input-container">
            <span class="label">Cost</span>
            <span class="input-icon">$</span>
            <input type="number" value="0.00" min="0" [(ngModel)]="cost" (ngModelChange)="costChanged()" step="any" class="get-Input-cost" />
        </div> -->
        <div class="input-container">
            <span class="label">Date</span>
            <span class="input-icon input-icon--mat cursor-pointer get-date-icon" (click)="picker.open()" matTooltip="{{ttDate}}">
                <i class="material-icons">date_range</i>
            </span>
            <input type="text" [matDatepicker]="picker" [min]="minDate" [max]="maxDate" placeholder="Choose a date" class="get-Input-date"
                [(ngModel)]="eventDate" (ngModelChange)="dateChanged()" readonly="readonly" style="color: black">
            <mat-datepicker #picker></mat-datepicker>
        </div>
        <div class="margin-bottom-16">Comment</div>
        <textarea rows="4" maxlength="256" [(ngModel)]="comment" (ngModelChange)="commentChanged()" class="textAreaComment"
            placeholder="Enter a comment about why the implement status was changed. "
            matTooltip="{{ttComment}}"></textarea>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span
                class="button__text">Save</span></a>
    </div>
</div>